import { cookieOf } from "@/lib/cookie";
import QuoteEditor from "@/modules/quote/ui/editor/quote-editor";
import RoughEditor from "@/modules/quote/ui/rough-editor";
import {
  parseShowCost,
  parseTableMode,
  parseView,
  SHOW_COST_COOKIE,
  TABLE_MODE_COOKIE,
  VIEW_COOKIE,
} from "@buildpy/core/modules/quote/editor/view-pref";
import type { QuoteEditView } from "@buildpy/core/views/g1c/quote-edit";

// 초안 편집기. 발송된 뒤에는 고칠 수 없으므로 상세로 돌려보낸다(view 가 한다) — 새 버전을 뜨는 것은 상세 화면의 일이다.
const Page = ({ data }: { data: QuoteEditView }) => {
  if (data.kind === "rough") {
    return (
      <RoughEditor
        customerName={data.customerName}
        customerSite={data.customerSite}
        detail={data.detail}
      />
    );
  }

  // 시트·카드 보기 — 쿠키로 받아 첫 그리기부터 맞춘다(새로고침에 카드로 튀지 않게).
  const initialView = parseView(cookieOf(VIEW_COOKIE));
  const initialTableMode = parseTableMode(cookieOf(TABLE_MODE_COOKIE));
  const initialShowCost = parseShowCost(cookieOf(SHOW_COST_COOKIE));

  return (
    // 다른 견적으로 넘어가면 편집기를 새로 세운다 — 잠김·자동저장 상태가 옛 견적에 남지 않게.
    <QuoteEditor
      key={data.detail.quote.id}
      baseRev={data.baseRev}
      calibration={data.calibration}
      canSaveTemplate={data.canSaveTemplate}
      customerName={data.customerName}
      customerSite={data.customerSite}
      detail={data.detail}
      initialShowCost={initialShowCost}
      initialTableMode={initialTableMode}
      initialView={initialView}
      memberId={data.memberId}
      phases={data.phases}
      restored={data.restored}
      spaces={data.spaces}
      standard={data.standard}
      templateTrades={data.templateTrades}
      tradeOptions={data.tradeOptions}
      tradePhases={data.tradePhases}
      validDays={data.validDays}
    />
  );
};

export default Page;
